// Custom components
import { Stack } from '@mui/material';
import SearchInput from 'components/Form/TextField/SearchField.cmp';
import StatusFilterDropdown from 'components/TaskAdvanceFilters/AdvancedFilterBuilder/FilterRow/FilterDropdowns/StatusFilter/StatusFilter';
import AssigneeFilterDropdown from 'components/AssigneeFilter/AssigneeFilter';
import useDropdownData from 'utils/CustomHooks/useDropdownData';
import LocationFilterDropdown from 'components/TaskAdvanceFilters/AdvancedFilterBuilder/FilterRow/FilterDropdowns/LocationFilter/locationFilters';
import CustomButton from 'components/Button/CustomButton';
import { TextRenderer } from 'components/TaskAdvanceFilters/QuickFilterBuilder/QuickFilterBuilder';
import { useSelector } from 'react-redux';
import selectors from 'store/selectors';
import { getTimeZone, downloadFile } from 'utils/globalFunction';
import xeniaApi from 'api/index';
import DateTime from 'utils/DateTime';

const Header = ({
  searchTerm,
  handleChangeSearch,
  filters,
  handleUpdateFilters,
  tasksIds,
}) => {
  const { selectedTaskAssignees, selectedStatus, selectTaskLocation } =
    useDropdownData();
  const orgHotelName = useSelector(selectors.getPropertyName);
  const tz: string = getTimeZone();

  const { locations, statusFilters, assigneeFilters } = filters;
  const handleChangeFilter = (filterName: string, filterValue: any) => {
    if (filterName === 'locations' || filterName === 'statusFilters') {
      filterValue = filterValue.map((item) => item.id);
    }
    handleUpdateFilters({
      ...filters,
      [filterName]: { value: filterValue },
    });
  };

  const handleDownloadCSV = async () => {
    let advanceFilters;
    if (tasksIds?.length > 0) {
      advanceFilters = {
        condition: 'AND',
        filters: [
          {
            filterName: 'ids',
            comparator: 'is',
            value: tasksIds,
            conditional: 'and',
          },
        ],
      };
    }

    const payload = {
      advanceFilters,
      searchText: searchTerm,
      view: 'list',
      viewType: 'current',
      hideCompleted: false,
    };

    const fileName = `${orgHotelName}_Work_Order_Report_${DateTime.fromTodayInTz(
      tz,
    ).toTzString(tz, 'MM-DD-YY')}`;

    const response = await xeniaApi.getTasksInExcel(payload);
    if (response?.data?.url)
      downloadFile(response?.data?.url, fileName + '.xlsx');
  };
  return (
    <Stack direction="row" alignItems="center" gap={1} mb={2}>
      <SearchInput
        grayInput={false}
        fieldProps={{
          value: searchTerm,
          onChange: (e) => handleChangeSearch(e),
        }}
        sx={{
          width: '250px',
          height: '40px',
          maxWidth: { sm: 'calc(100vw - 140px)', md: 250 },
          '& .MuiInputBase-root': {
            borderRadius: '8px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E0E0E0',
          },
        }}
      />

      <StatusFilterDropdown
        onChangeCallback={(option) =>
          handleChangeFilter('statusFilters', option)
        }
        selected={selectedStatus(statusFilters?.value || [])}
        // selected={statusFilters?.value || []}
        buttonProps={{
          variant: 'outlined',
          buttonType: 'gray',
          sx: {
            borderRadius: '8px',
            width: 'auto',
            border: '1px solid #ECEEF6',
            '& .MuiButton-endIcon svg': {
              color: '#6868FE',
            },
          },
          textRenderer: TextRenderer,
        }}
      />
      <AssigneeFilterDropdown
        onChangeCallback={(option) => {
          handleChangeFilter(
            'assigneeFilters',
            option.map((item) => item.id),
          );
        }}
        selected={selectedTaskAssignees(assigneeFilters?.value || [])}
        // selected={assigneeFilters?.value || []}
        buttonProps={{
          textRenderer: TextRenderer,
          variant: 'outlined',
          buttonType: 'gray',
          sx: {
            borderRadius: '8px',
            width: 'auto',
            maxWidth: 'max-content',
            border: '1px solid #ECEEF6',
            '& span:first-of-type': {
              width: '100%',
            },
            '& .MuiButton-endIcon svg': {
              color: '#6868FE',
            },
          },
        }}
      />
      <LocationFilterDropdown
        onChangeCallback={(option) => handleChangeFilter('locations', option)}
        selected={selectTaskLocation(locations?.value || [])}
        // selected={locations?.value || []}
        showAuthorizedLocations
        buttonProps={{
          variant: 'outlined',
          buttonType: 'gray',
          sx: {
            borderRadius: '8px',
            width: 'auto',
            border: '1px solid #ECEEF6',
            '& .MuiButton-endIcon svg': {
              color: '#6868FE',
            },
          },
          textRenderer: TextRenderer,
        }}
      />

      <CustomButton
        variant="outlined"
        buttonType="gray"
        sx={{
          borderRadius: '8px',
          width: 'auto',
          marginLeft: 'auto',
          border: '1px solid #ECEEF6',
          '& .MuiButton-endIcon svg': {
            color: '#6868FE',
          },
        }}
        onClick={() => {
          handleUpdateFilters({
            locations: { value: [] },
            statusFilters: { value: [] },
            assigneeFilters: { value: [] },
          });
        }}
      >
        Reset Filters
      </CustomButton>

      <CustomButton
        variant="outlined"
        buttonType="gray"
        onClick={handleDownloadCSV}
        disabled={tasksIds.length === 0}
        sx={{
          borderRadius: '8px',
          width: 'auto',
          border: '1px solid #ECEEF6',
          '& .MuiButton-endIcon svg': {
            color: '#6868FE',
          },
        }}
      >
        Download CSV
      </CustomButton>
    </Stack>
  );
};

export default Header;
